import { createFileRoute } from '@tanstack/react-router'
import MoveFoldertModal from '../../../../../../../containers/project-menu/components/move-items-modals/move-folder-modal'
import { moveFolderSearchSchema } from '../../../search-schemas'

export const Route = createFileRoute(
  '/_authenticated/project/_projects/move/folder/$folderId/'
)({
  validateSearch: moveFolderSearchSchema,
  component: MoveFoldertModal
})
